"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryOfChanges = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const buttons_1 = require("../../atoms/buttons");
const Content_1 = require("./Content");
const loading_1 = require("../../molecules/loading");
const Top = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(TopBar, { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("historyOfChanges.topBar.action") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("historyOfChanges.topBar.who") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("historyOfChanges.topBar.when") }, void 0)] }, void 0));
};
const TopBar = styled_components_1.default.div `
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  & h4 {
    flex: 1;
  }

  & h4:first-of-type,
  & h4:last-of-type {
    flex: 2;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => `${theme.spacings.m}`};
    column-gap: ${({ theme }) => theme.spacings.xxs};
  }
`;
const Bottom = ({ onClick, isMoreItems }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleOnClick = async () => {
        try {
            setIsLoading(true);
            await onClick();
        }
        finally {
            setIsLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(BottomBar, { isLoading: isLoading, children: [(0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsx)("div", { children: isLoading ? ((0, jsx_runtime_1.jsx)(Loader, { children: (0, jsx_runtime_1.jsx)(loading_1.Loading, {}, void 0) }, void 0)) : ((0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "link", onClick: handleOnClick, disabled: !isMoreItems, children: t("historyOfChanges.bottomBar.loadMore") }, void 0)) }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, void 0));
};
const Loader = styled_components_1.default.div `
  & > div {
    justify-content: flex-start;
  }

  .loader {
    margin-left: 2.5rem;
    transform: translateY(-0.5rem);
  }

  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
    width: 10px;
    height: 10px;
  }
`;
const BottomBar = styled_components_1.default.div `
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  padding: ${({ theme, isLoading }) => isLoading ? "0" : `${theme.spacings.xs} 0`};

  & > div {
    flex: 1;
  }

  & > div:first-of-type,
  & > div:last-of-type {
    flex: 2;
  }

  & button {
    line-height: 1.5rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div {
      flex: 2;
    }

    & > div:last-of-type {
      flex: 1;
    }
  }
`;
const HistoryOfChanges = ({ events, onLoadMore, unit, isMoreItems }) => {
    const onClick = () => onLoadMore(events[events.length - 1].id);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(Top, {}, void 0), (0, jsx_runtime_1.jsx)(Content_1.Content, { events: events, unit: unit }, void 0), (0, jsx_runtime_1.jsx)(Bottom, { onClick: onClick, isMoreItems: isMoreItems }, void 0)] }, void 0));
};
exports.HistoryOfChanges = HistoryOfChanges;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  height: 100%;

  p,
  h4 {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=index.js.map